export const RedError = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M22 12C22 17.5229 17.5229 22 12 22C6.47715 22 2 17.5229 2 12C2 6.47715 6.47715 2 12 2C17.5229 2 22 6.47715 22 12ZM15.5358 8.46428C15.9264 8.8548 15.9264 9.48797 15.5358 9.87849L13.4148 11.9995L15.5364 14.1211C15.927 14.5117 15.927 15.1448 15.5364 15.5353C15.1459 15.9259 14.5128 15.9259 14.1222 15.5353L12.0006 13.4137L9.87898 15.5353C9.48846 15.9259 8.85529 15.9259 8.46477 15.5353C8.07424 15.1448 8.07424 14.5117 8.46477 14.1211L10.5864 11.9995L8.46537 9.87849C8.07485 9.48797 8.07485 8.8548 8.46537 8.46428C8.8559 8.07376 9.48906 8.07376 9.87959 8.46428L12.0006 10.5853L14.1216 8.46428C14.5121 8.07376 15.1453 8.07376 15.5358 8.46428Z"
        fill="#D24D57"
        fillRule="evenodd"
      />
    </svg>
  );
};
